'use client';

import { HamburgerMenuIcon } from '@radix-ui/react-icons';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { LogoBlackIcon } from '@/icons';
import { LANDING_LINKS } from './constants';

const MobileNav = ({ activeId }: { activeId: string | null }) => {
  const [isOpen, setIsOpen] = useState(false);
  const pathname = usePathname();

  return (
    <Collapsible
      open={isOpen}
      onOpenChange={setIsOpen}
      className='bg-bui-color-white'
    >
      <div className='flex items-center justify-between gap-4'>
        <Link
          href='/'
          className='inline-block'
          aria-label='Booli, till startsidan.'
        >
          <LogoBlackIcon />
        </Link>
        <div className='flex items-center gap-4'>
          <a href='/auth/login'>
            <Button variant={'outline'}>Logga in</Button>
          </a>
          <CollapsibleTrigger asChild>
            <Button>
              <HamburgerMenuIcon className='h-4 w-4' />
              <span className='sr-only'>Expandera</span>
            </Button>
          </CollapsibleTrigger>
        </div>
      </div>
      <CollapsibleContent
        className='pointer-events-none fixed inset-0 top-16 z-100 bg-inherit px-8 opacity-0 shadow-lg
          transition-opacity duration-100 ease-in-out data-[state=open]:pointer-events-auto
          data-[state=open]:opacity-100'
      >
        <div className='flex flex-col items-end gap-6 font-semibold'>
          {LANDING_LINKS.map(({ id, label }) => (
            <Link
              key={id}
              href={`/#${id}`}
              data-active={activeId === id}
              className='data-[active=true]:text-bui-color-orange'
              onClick={() => setIsOpen(false)}
            >
              {label}
            </Link>
          ))}
          <Link
            href='/indices'
            data-active={pathname.includes('indices')}
            className='data-[active=true]:text-bui-color-orange'
            onClick={() => setIsOpen(false)}
          >
            Prisindex
          </Link>
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
};

export default MobileNav;
